import React, { useState, useEffect } from "react";
import {
  Paper,
  Stepper,
  Step,
  StepLabel,
  Typography,
  CircularProgress,
  Divider,
  Button,
  CssBaseline,
} from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";

import { commerce } from "../../../lib/commerce";
import useStyles from "./styles";

import AddressForm from "../AddressForm";
import PaymentForm from "../PaymentForm";

const steps = ["Shipping address", "Payment details"];

const Checkout = ({ cart, order, onCaptureCheckout, error, refreshCart }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [checkoutToken, setCheckoutToken] = useState(null);
  const [shippingData, setShippingData] = useState({});
  const [isFinished, setIsFinished] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    const generateToken = async () => {
      try {
        const token = await commerce.checkout.generateToken(cart.id, {
          type: "cart",
        });

        setCheckoutToken(token);
      } catch (error) {}
    };

    generateToken();
  }, [cart]);

  const nextStep = () => setActiveStep((previousStep) => previousStep + 1);
  const prevStep = () => setActiveStep((previousStep) => previousStep - 1);

  const next = (data) => {
    setShippingData(data);

    nextStep();
  };

  const timeOut = () => {
    setTimeout(() => {
      setIsFinished(true);
    }, 3000);
  };

  let Confirmation = () => (
    <>
      <div>
        <Typography variant="h5">Thank you for your purchase,</Typography>
        <Divider className={classes.divider} />
      </div>
      <br />
      <Button component={Link} to="/" variant="outlined" type="button">
        Back to Home
      </Button>
    </>
    // order.customer ? (
    //   <>
    //     <div>
    //       <Typography variant="h5">
    //         Thank you for your purchase, {order.customer.firstname}{" "}
    //         {order.customer.lastname}
    //       </Typography>
    //       <Divider className={classes.divider} />
    //       <Typography variant="subtitle1">
    //         {" "}
    //         Order ref: {order.customer_reference}
    //       </Typography>
    //     </div>
    //     <br />
    //     <Button component={Link} to="/" variant="outlined" type="button">
    //       Back to Home
    //     </Button>
    //   </>
    // ) : (
    //   <div className={classes.spinner}>
    //     <CircularProgress />
    //   </div>
  );

  if (error) {
    <>
      <Typography variant="h5">Error: {error}</Typography>
      <Button component={Link} to="/" variant="outlined" type="button">
        Back to Home
      </Button>
    </>;
  }

  const Form = () =>
    activeStep === 0 ? (
      <AddressForm checkoutToken={checkoutToken} next={next} />
    ) : (
      <PaymentForm
        shippingData={shippingData}
        checkoutToken={checkoutToken}
        nextStep={nextStep}
        prevStep={prevStep}
        onCaptureCheckout={onCaptureCheckout}
        refreshCart={refreshCart}
        timeOut={timeOut}
      />
    );

  return (
    <>
      <CssBaseline />
      <div className={classes.toolbar} />
      <div className={classes.layout}>
        <Paper className={classes.paper}>
          <Typography variant="h4" align="center">
            Checkout
          </Typography>
          <Stepper activeStep={activeStep} className={classes.stepper}>
            {steps.map((step) => (
              <Step key={step}>
                <StepLabel>{step}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length ? (
            <Confirmation />
          ) : (
            checkoutToken && <Form />
          )}
        </Paper>
      </div>
    </>
  );
};

export default Checkout;
